import React from 'react';
import dayjs from 'dayjs';
import { useCalendar } from '../../../contexts/CalendarContext';
const months = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];
const daysOfWeek = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
const getDaysInMonth = (month, year) => {
    return new Date(year, month + 1, 0).getDate();
};
export const CustomCalendar = ({ onSelectDate }) => {
    const { selectedDepartureDate, selectedReturnDate, selectDate } = useCalendar();
    const today = dayjs();
    const currentMonth = today.month();
    const currentYear = today.year();
    const monthsToShow = 12;
    const handleDateClick = (date) => {
        selectDate(date);
        onSelectDate(selectedDepartureDate, selectedReturnDate);
    };
    // Regras de datas desabilitadas
    const disabledDate = (current) => {
        const tomorrowStart = dayjs().add(3, 'day').startOf('day');
        const oneYearFromNow = dayjs().add(1, 'year').endOf('day');
        if (current.isBefore(tomorrowStart))
            return true;
        if (current.isAfter(oneYearFromNow))
            return true;
        if (selectedDepartureDate && current.isSame(dayjs(selectedDepartureDate), 'day'))
            return true;
        return false;
    };
    return (React.createElement("div", { className: "max-h-[calc(100vh-100px)]" },
        React.createElement("div", { className: "grid grid-cols-1 gap-4" }, Array.from({ length: monthsToShow }, (_, index) => {
            const month = (currentMonth + index) % 12;
            const year = currentYear + Math.floor((currentMonth + index) / 12);
            return (React.createElement("div", { key: index, className: "rounded-md flex flex-col h-[296px] gap-5", "data-testid": "calendar" },
                React.createElement("h3", { className: "text-left mt-5 font-semibold" },
                    months[month],
                    " ",
                    year),
                React.createElement("div", { className: "grid grid-cols-7 text-center flex-grow" },
                    daysOfWeek.map((day) => (React.createElement("div", { key: day, className: "text-[#666666] border-y border-gray-10 p-2 mb-2" }, day))),
                    (() => {
                        const daysInMonth = getDaysInMonth(month, year);
                        const firstDayOfWeek = new Date(year, month, 1).getDay();
                        const totalCells = daysInMonth + firstDayOfWeek;
                        return Array.from({ length: totalCells }, (_, dayIndex) => {
                            if (dayIndex < firstDayOfWeek) {
                                return React.createElement("div", { key: `empty-${dayIndex}` });
                            }
                            const day = dayIndex - firstDayOfWeek + 1;
                            const date = new Date(year, month, day);
                            const dateJs = dayjs(date);
                            const isDepartureDate = (selectedDepartureDate === null || selectedDepartureDate === void 0 ? void 0 : selectedDepartureDate.toDateString()) === date.toDateString();
                            const isReturnDate = (selectedReturnDate === null || selectedReturnDate === void 0 ? void 0 : selectedReturnDate.toDateString()) === date.toDateString();
                            const isBetweenDates = selectedDepartureDate &&
                                selectedReturnDate &&
                                date > selectedDepartureDate &&
                                date < selectedReturnDate;
                            const isToday = today.isSame(dateJs, 'day');
                            const isDisabled = disabledDate(dateJs);
                            const disabledClasses = isDisabled
                                ? 'text-[#999] line-through cursor-not-allowed'
                                : '';
                            const cellClasses = `
                      py-1
                      ${isDepartureDate
                                ? `bg-[#000] text-white ${selectedDepartureDate && !selectedReturnDate
                                    ? 'rounded-full'
                                    : 'rounded-l-lg'}`
                                : ''}
                      ${isReturnDate ? 'bg-[#000] text-white rounded-r-lg' : ''}
                      ${isBetweenDates ? 'bg-[#f2f2f2]' : ''}
                      ${disabledClasses}
                      ${isToday ? 'cursor-not-allowed' : 'cursor-pointer'}
                    `;
                            return (React.createElement("div", { key: dayIndex, className: cellClasses, onClick: () => (!isDisabled && !isToday) && handleDateClick(date) },
                                React.createElement("span", { className: isToday
                                        ? 'inline-flex line-through items-center justify-center w-7 h-7 rounded-full border border-[#ff7020] mx-auto'
                                        : '' }, day)));
                        });
                    })())));
        }))));
};
//# sourceMappingURL=index.js.map